class Table {
    id;
    name;
    bigBlind;
    smallBlind;
    playersNumber;
    seatsNumber;
    pot;
    card1;
    card2;
    card3;
    card4;
    card5;
    timeLimit;
    winnerCards;
    sitOutTimeLimit;

    constructor(id, name, bigBlind, smallBlind, playersNumber, seatsNumber, pot, card1, card2, card3, card4, card5, timeLimit, winnerCards, sitOutTimeLimit) {
        this.id = id;
        this.name = name;
        this.bigBlind = bigBlind;
        this.smallBlind = smallBlind;
        this.playersNumber = playersNumber;
        this.seatsNumber = seatsNumber;
        this.pot = pot;
        this.card1 = card1;
        this.card2 = card2;
        this.card3 = card3;
        this.card4 = card4;
        this.card5 = card5;
        this.timeLimit = timeLimit;
        this.winnerCards = winnerCards;
        this.sitOutTimeLimit = sitOutTimeLimit;
    }
}

export default Table;
